import React, { useState, useEffect, useRef } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IoIosCall } from 'react-icons/io';
import { CgMail } from 'react-icons/cg';
import { useNavigate } from 'react-router-dom';
import logo from '../../Assets/images/Frame 39059 1.png';
import TopHeader from './TopHeader';

const Header = ({ setIsOurCourses }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [position, setPosition] = useState({ top: '50%', left: '50%' });
  const [activeNav, setActiveNav] = useState('');
  const navigate = useNavigate();

   const menuRef = useRef(null);

  const moveButton = () => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Generate random positions within the viewport bounds
    const randomX = Math.random() * (screenWidth - 100); // Adjust for button width
    const randomY = Math.random() * (screenHeight - 50); // Adjust for button height

    setPosition({ top: `${randomY}px`, left: `${randomX}px` });
  };

  const handleNavigation = (path, item) => {
    setActiveNav(item);

    navigate(path);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false); // Close the menu when clicking outside
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
  
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header
      className={`w-full  z-50 fixed top-0 left-0  transition-all duration-300 ease-in-out  ${
        isScrolled ? 'bg-opacity-95 shadow-lg' : 'bg-transparent'
      }`}
    >
      {/* Top Header */}
      {/* <div className=" bg-dark-blue">
        <div className="flex justify-between items-center py-1 md:px-0 md:py-4  text-white gap-3 px-2  container mx-auto">
          <div className="md:flex space-x-1 md:space-x-6 md:text-xs text-xs">
            <div className="flex items-center space-x-1">
              <IoIosCall className="text-gray-200 ml-2" />
              <h6>01743216756</h6>
            </div>
            <div className="flex items-center space-x-1">
              <CgMail className="text-gray-200 ml-1" />
              <h6>tenderwise.xyz@gmail.com</h6>
            </div>
          </div>
          <div className="text-gray-200 text-xs md:text-xs flex flex-col sm:flex-row md:flex-row lg:flex-row ">
            <p className="text-nowrap">Last Updated:</p>{' '}
            <p className="text-nowrap">04-02-2025, 07:16 PM</p>
          </div>
        </div>
      </div> */}
      <TopHeader/>

      {/* Bottom Header / Navbar */}
      <div
        className={`w-full bg-gray-100 shadow-md  ${
          isScrolled ? 'bg-gray-200 shadow-lg' : ''
        }`}
      >
        <nav className="flex justify-between items-center md:px-0 px-2 py-0 md:py-2 container mx-auto">
          <a
            // onClick={() => handleNavigation('/')}
            href="/"
            className="flex items-center space-x-0 cursor-pointer"
          >
            <img src={logo} alt="Logo" className="md:h-16 w-36 h-14 md:w-44" />
          </a>

          {/* Desktop Menu */}
          <ul className="hidden lg:flex space-x-6 text-gray-700 font-bold ml-36">
            {[
              // 'All Tenders',
              // 'Our Courses',
              'Tender Publish',
              'Pricing',
              'Contact Us',
              'About Us',
            ].map((item, index) => (
              <li key={index}>
                <button
                  onClick={() =>
                    handleNavigation(
                      item === 'Tender Publish'
                        ? '/tenderpublish'
                        : item === 'Pricing'
                        ? '/pricing'
                        : item === 'About Us'
                        ? '/about'
                        : // : item === 'Our Courses'
                          // ? '/ourcourses'
                          `/${item.replace(/\s/g, '').toLowerCase()}`,
                      item
                    )
                  }
                  className={`${
                    activeNav === item
                      ? 'text-tenderLogoColor border-b-2 border-tenderLogoColor'
                      : ''
                  } hover:text-tenderLogoColor hover:border-b-2 border-tenderLogoColor hover:shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110`}
                >
                  {item}
                </button>
              </li>
            ))}
          </ul>
          <div className="space-x-2 ml-auto mr-2 md:mr-0 md:block hidden">
            <button
              onClick={() => handleNavigation('/signup')}
              className="text-sm  md:py-1.5 py-1 md:px-4 px-2 bg-headerBtn text-white rounded-lg hover:bg-blue-500"
            >
              Registration/Login
            </button>
          </div>

          <div className="md:hidden flex items-center space-x-4">
            <button
              onClick={() => handleNavigation('/signup')}
              className="text-xs  py-1 px-2 bg-headerBtn text-white rounded-lg hover:bg-blue-500"
            >
              Registration/Login
            </button>
            {/* Mobile Menu Button */}
            <button
              onClick={toggleMenu}
              className="text-gray-700 focus:outline-none"
            >
              {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </nav>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div ref={menuRef} className="lg:hidden bg-blue-800 bg-opacity-90">
            <ul className="flex flex-col space-y-4 text-gray-300 px-4 pb-4 pt-4">
              {[
                'Home',
                'Pricing',
                'Tender Publish',
                'About Us',
                'Contact Us',
                // 'Our Courses',
              ].map((item, index) => (
                <li key={index}>
                  <button
                    onClick={() =>
                      handleNavigation(
                        item === 'Home'
                          ? '/'
                          : item === 'About Us'
                          ? '/about'
                          : // : item === 'Our Courses'
                            // ? '/ourcourses'
                            `/${item.replace(/\s/g, '').toLowerCase()}`
                      )
                    }
                    className="hover:text-tenderLogoColor hover:border-b-2 border-tenderLogoColor hover:shadow-lg transition-all duration-300 ease-in-out transform hover:scale-110"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;

